import { ReactNode } from "react";
import { Box, useMediaQuery } from "@mui/material";

import { useTypedTheme } from "hooks";

type Props = {
  children: ReactNode;
  fullWidth?: boolean;
};

export const Section = ({ children, fullWidth = false }: Props) => {
  // styles
  const {
    theme: {
      breakpoints: { down },
    },
  } = useTypedTheme();
  const isMobile = useMediaQuery(down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        borderRadius: 4,
        flexBasis: isMobile ? "100%" : "70%",
        margin: fullWidth ? "0 auto" : 0,
        width: isMobile ? "100%" : "70%",
      }}
    >
      {children}
    </Box>
  );
};
